import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { DDS_DEFAULT_DURATION_MINUTES } from '@/types'
import { type DdsFormData, ddsSchema } from '../../schemas/dds-schema'

export function useDDSForm() {
	return useForm<DdsFormData>({
		defaultValues: {
			description: '',
			subject: '',
			type: '',
			attendeeIds: [],
			attendanceEnabled: false,
			durationMinutes: DDS_DEFAULT_DURATION_MINUTES,
			image: undefined,
		},
		resolver: zodResolver(ddsSchema),
		shouldFocusError: true,
		mode: 'onSubmit',
	})
}
